module.exports = __webpack_public_path__ + "img/puberty-decal-08.732f2f59.png";